import { ActionTypes } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';

import OpenGolfService from '../services/OpenGolfService';
import OpenSearchRecord from '../records/widgets/OpenSearchRecord';

const OpenGolfActions = {
    async loadFromParams(params) {
        let openSearch = await OpenSearchRecord.deserialize(params);

        return openSearch;
    },

    addLoadingTrip(trip) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.OPEN_GOLF_ADD_TRIP,
            trip
        });
    },

    async getTickets(search) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.OPEN_GOLF_GET_TICKETS_STARTED
        });

        try {
            const response = await OpenGolfService.getTickets(search);

            AppDispatcher.dispatch({
                actionType: ActionTypes.OPEN_GOLF_GET_TICKETS_ENDED,
                tickets: response
            });
        } catch (error) {
            AppDispatcher.dispatch({
                actionType: ActionTypes.OPEN_GOLF_GET_TICKETS_FAILED,
                error
            });
        }
    },
};

export default OpenGolfActions;



// WEBPACK FOOTER //
// ./src/actions/OpenGolfActions.js